interface Props {
  language: 'de' | 'en'
  onContinue: () => void
  onBack?: () => void
}

const content = {
  de: {
    h1: 'Dein Interview mit TEMBO',
    temboH2: 'TEMBO',
    temboSubtitle: 'TEMBO ist ein KI gestützter, fotorealistischer Avatar, der dich als Recruiter durch ein kurzes Kennenlerngespräch führt.',
    temboText: 'In den nächsten Minuten wird dir TEMBO ein paar Fragen stellen, um dich besser kennen zu lernen.',
    structureIntro: 'Das Interview folgt dabei einer klaren Struktur:',
    steps: [
      'Vorstellung des Unternehmens und der Stelle durch TEMBO',
      'Du stellst dich ebenfalls kurz vor',
      'Übergang in das Interview durch TEMBO',
      'Abschluss durch TEMBO',
      'Angabe deiner Daten für die Kontaktaufnahme',
    ],
    note: 'Deine Daten werden ausschließlich zweckgebunden, datenschutz- und EU AI Act-konform verarbeitet.',
    controlsH2: 'Bedienelemente',
    controlsSubtitle: 'Übersicht über wichtige Steuerungselemente',
    screenshotAlt: 'Bedienelemente',
    screenshotSrc: '/images/instructions-de.png',
    footer: 'TEMBO ist ein Produkt der elephant recruiting GmbH. Weitere Informationen:',
    continueBtn: 'Weiter',
  },
  en: {
    h1: 'Your Interview with TEMBO',
    temboH2: 'TEMBO',
    temboSubtitle: 'TEMBO is an AI-powered, photorealistic avatar that guides you as a recruiter through a short introductory conversation.',
    temboText: 'Over the next few minutes, TEMBO will ask you a few questions to get to know you better.',
    structureIntro: 'The interview follows a clear structure:',
    steps: [
      'Introduction of the company and position by TEMBO',
      'You briefly introduce yourself',
      'Transition into the interview by TEMBO',
      'Closing by TEMBO',
      'Providing your contact details',
    ],
    note: 'Your data will be processed exclusively for the stated purpose, in compliance with data protection regulations and the EU AI Act.',
    controlsH2: 'Controls',
    controlsSubtitle: 'Overview of important control elements',
    screenshotAlt: 'Control elements',
    screenshotSrc: '/images/instructions-en.png',
    footer: 'TEMBO is a product of elephant recruiting GmbH. More information:',
    continueBtn: 'Continue',
  },
}

export function InstructionModal({ language, onContinue, onBack }: Props) {
  const c = content[language]
  const backLabel = language === 'de' ? '← Zurück' : '← Back'

  return (
    <div className="tembo-demo-overlay">
      <div className="instruction-modal-container">
        {onBack && (
          <button className="back-btn" onClick={onBack}>
            {backLabel}
          </button>
        )}
        <h1 className="instruction-modal-h1">{c.h1}</h1>

        <div className="instruction-modal-columns">
          {/* Left Column */}
          <div className="instruction-modal-column instruction-modal-left">
            <h2 className="instruction-modal-h2">{c.temboH2}</h2>
            <p className="instruction-modal-subtitle">{c.temboSubtitle}</p>
            <p className="instruction-modal-text">{c.temboText}</p>
            <p className="instruction-modal-structure-intro">{c.structureIntro}</p>
            <ol className="instruction-modal-list">
              {c.steps.map((step, i) => (
                <li key={i}>{step}</li>
              ))}
            </ol>
            <p className="instruction-modal-note">{c.note}</p>
          </div>

          {/* Right Column */}
          <div className="instruction-modal-column instruction-modal-right">
            <h2 className="instruction-modal-h2">{c.controlsH2}</h2>
            <p className="instruction-modal-subtitle">{c.controlsSubtitle}</p>
            <div className="instruction-screenshot-container">
              <img
                src={c.screenshotSrc}
                alt={c.screenshotAlt}
                className="instruction-screenshot"
              />
            </div>
          </div>
        </div>

        <div className="instruction-modal-footer">
          {c.footer}{' '}
          <a href="https://www.tlou.ai" target="_blank" rel="noreferrer">www.tlou.ai</a> |{' '}
          <a href="mailto:hello@tlou.ai">hello@tlou.ai</a> |{' '}
          +49 177 8058820
        </div>

        <button className="instruction-continue-btn" onClick={onContinue}>
          <span>{c.continueBtn}</span>
        </button>
      </div>
    </div>
  )
}
